import { gql } from '@apollo/client';

export const FILTERED_WORKSPACES = gql`
  query FilteredWorkspaces($input: WorkspaceInput) {
    workspaces: filteredWorkspaces(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          isArchived
          lastModified
          lastSubmitted
          programmes {
            id
            name
          }
          forms {
            id
            name
          }
          datasets {
            id
          }
        }
      }
    }
  }
`;
